import { Repositories } from ".."
import { dutchOrderPlatesActions, dutchOrderPlatesStore } from "../state"

export async function loadData() {
    const { model } = dutchOrderPlatesStore.getState().dutchOrderPlates
    dutchOrderPlatesActions.setLoading()

    Repositories.orderPlates(model).then(
        (res) => dutchOrderPlatesActions.setLoaded(res),
        () => dutchOrderPlatesActions.setError()
    )
}
